import "./style.scss";
import React, { useEffect, useState, useRef } from "react";
import imageCompression from "browser-image-compression";
import { uploadImageApi } from "services/NexiDigitalAPI";
import ImageCropList from "components/ImageCropList";

type Props = {
  className?: string;
  reference: any;
  data: any;
  defaultPrefixName?: string;
};

function ContentImageUploadV2({ className = "", data, defaultPrefixName, reference }: Props) {
  const imagesToUpload: any = useRef([]);
  const [defaultUploadedImage, setDefaultUploadedImage] = useState(null);
  const [carregaImagem, setCarregaImagem] = useState(false);
  const baseImage = useRef(
    data.image !== null && data.image !== ""
      ? data.image
          .split("/")
          .slice(0, data.image.length - 1)
          .splice(-1, 1)
          .join()
          .split(".")[0]
      : defaultPrefixName
      ? `${defaultPrefixName}-${Date.now()}`
      : `image-${Date.now()}`
  );

  const [imagemUploadStatus, setImagemUploadStatus] = useState(false);
  const [mensagemImagemUpload, setMensagemImagemUpload] = useState("");
  // const editContent = useRef(data.image === null || data.image === "" ? false : true);

  const contentData = useRef(data);

  console.log("teste imagem ContentImageUploadV2");

  useEffect(() => {
    if (reference) {
      reference.current = {
        uploadImagem,
        onCropImage,
        uploadDefaultImage,
        imagesToUpload,
      };
    }
  }, [reference]);

  const uploadImagem = async (e: any) => {
    if (e) {
      e.preventDefault();
    }

    setMensagemImagemUpload("");

    // const options = {
    //   maxSizeMB: 0.9,
    //   maxWidthOrHeight: 1920,
    //   fileType: "image/webp",
    // };

    const options = {
      maxSizeMB: 2, //
      maxWidthOrHeight: 1920, // mantém a resolução original
      fileType: "image/blob", // mantém o tipo original (jpeg/png/etc)
      useWebWorker: true, // processamento em background
      initialQuality: 1.0, // qualidade máxima
      alwaysKeepResolution: true, // evita reduzir resolução
      preserveExif: true, // preserva metadados, se quiser manter
    };

    const baseImageObject = imagesToUpload.current.filter(
      (x: any) => x.imageFormatName.indexOf("-format-landscape-large") !== -1
    );

    if (baseImageObject.length > 0) {
      imagesToUpload.current.push({
        imageFormatName: baseImage.current,
        file: baseImageObject[0].file,
        aspectRatio: baseImageObject[0].aspectRatio,
        blob: baseImageObject[0].blob,
      });
    }

    const promise = new Promise(async (resolve, reject) => {
      setCarregaImagem(true);
      if (imagesToUpload.current.length === 0) {
        resolve(null);
      }

      while (imagesToUpload.current.length > 0) {
        const currentImageObject = imagesToUpload.current.shift();
        const imageFile = currentImageObject.file;

        try {
          const compressedFile = await imageCompression(imageFile, options);
          const filename = currentImageObject.imageFormatName;
          const dataFormat = new FormData();
          if (compressedFile) {
            dataFormat.append("fileName", filename);
            dataFormat.append("fileData", compressedFile);

            const response = await uploadImageApi(dataFormat);
            if (response) {
              if (response.data?.error) {
                setCarregaImagem(false);
                setImagemUploadStatus(false);
                setMensagemImagemUpload("Erro ao fazer upload do arquivo");
              } else {
                if (baseImageObject.length >= 0) {
                  if (filename === baseImage.current) {
                    resolve(response.data?.location);
                    successImagemAll();
                    return;
                  }
                }
                if (imagesToUpload.current.length === 0) {
                  resolve(null);
                }
              }
            } else {
              setCarregaImagem(false);
              setImagemUploadStatus(false);
              setMensagemImagemUpload("Erro ao fazer upload do arquivo");
            }
          }
        } catch (error) {
          console.log(error);
        }

        // if (imagesToUpload.current.length == 0) {
        //   successImagemAll();
        // }
      }
    });
    promise.finally(() => setCarregaImagem(false));
    return promise;
  };

  const successImagemAll = () => {
    setCarregaImagem(false);
    setImagemUploadStatus(true);
    setMensagemImagemUpload("Imagens atualizadas com successo.");
  };

  const onCropImage = async (croppedImage: any) => {
    imagesToUpload.current = imagesToUpload.current.filter(
      (x: any) => x.imageFormatName !== croppedImage.imageFormatName
    );

    imagesToUpload.current.push(croppedImage);
  };

  const uploadDefaultImage = async (arquivo: any) => {
    const imageFile = arquivo.files[0];
    setDefaultUploadedImage(window.URL.createObjectURL(imageFile));
  };

  return (
    <div className={`pctContentImageNodeUpload ${className}`}>
      <div className="node-images-crop-body">
        {!carregaImagem && (
          <label className="content-page-file-button btn">
            {contentData.current.image || defaultUploadedImage
              ? "SUBSTITUIR TODAS AS IMAGENS"
              : "ADICIONAR IMAGEM"}
            <input
              type="file"
              className="form-control-file"
              id="imagem"
              accept="image/png, image/jpeg, image/gif"
              onChange={(e) => {
                uploadDefaultImage(e.target);
              }}
            />
          </label>
        )}

        <ImageCropList
          contentData={contentData}
          defaultUploadedImage={defaultUploadedImage}
          baseImage={baseImage}
          onCropImage={onCropImage}
          carregaImagem={carregaImagem}
        />

        <div className="content-page-img-feedback">
          {imagemUploadStatus ? (
            <span style={{ color: "green", marginTop: 5 }}>{mensagemImagemUpload}</span>
          ) : (
            <span style={{ color: "red", marginTop: 5 }}>{mensagemImagemUpload}</span>
          )}
        </div>
      </div>
    </div>
  );
}

export default ContentImageUploadV2;
